import { Tooltip } from "@/components/tooltip";
import { LikeSolidIcon } from "@/icons";
import Link from "next/link";

export function LikesCounter({ likes }: { likes: number }) {
  return (
    <div className="flex items-start xl:gap-2 w-full">
      <LikeSolidIcon
        width={24}
        className="hidden xl:block fill-secondary group-active/like:animate-swing"
      />
      <span className="text-secondary xl:text-input text-xs xl:text-base">
        Você votou em{" "}
        <Link
          href="/votacao/votos"
          className="font-semibold text-primary xl:text-secondary underline hover:no-underline"
        >
          {likes} de 5
        </Link>{" "}
        problemas.
      </span>
      <Tooltip
        title="Painel de votação"
        description="Você pode votar em até 5 problemas referentes aos temas abordados."
        linkLabel="Saiba mais sobre a Participação Cidadã no TCU."
        linkUrl="https://portal.tcu.gov.br/imprensa/noticias/tcu-lanca-portal-que-permite-participacao-ativa-da-sociedade"
        className="ml-1"
        iconClass="stroke-primary xl:stroke-secondary w-4 h-4 lg:w-5 lg:h-5"
      />
    </div>
  );
}
